import { OPEN_WECHAT_POPUP, SET_WECHAT_URL, TOGGLE_WECHAT_POPUP } from '../actions/weChatPopup';

const initialState = {
  isOpen: false,
  wechatUrl: null,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_WECHAT_POPUP:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case OPEN_WECHAT_POPUP:
      return {
        ...state,
        isOpen: true,
      };
    case SET_WECHAT_URL:
      return {
        ...state,
        wechatUrl: action.payload,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
